import i18n from '@/i18n';
import DOMPurify from 'dompurify';
import { Directive, DirectiveBinding } from 'vue';
import { Address } from '../models/address.interface';

const sanitizer = DOMPurify();

export function formatAddress(address: any, wrap = false) {
   const box = address?.box ? `${i18n.global.t('generic.box')}: ${address.box}` : '';

   const result = sanitizer.sanitize(
      `${address?.street || ''} ${address?.house_number || ''} ${box} ${wrap && address.street ? '<br>' : ''} ${
         address?.city?.postal_code || ''
      } ${address?.city?.name?.[i18n.global.locale.value] || address?.city?.name || ''}`.trim(),
   );
   return result || '-';
}

function addressFormatter(el: HTMLElement, { value, arg }: DirectiveBinding<Address>) {
   el.innerHTML = formatAddress(value, arg === 'wrap');
}

const AddressFormatter: Directive = {
   mounted: addressFormatter,
   updated: addressFormatter,
};

export default AddressFormatter;
